export default __webpack_public_path__ + "static/04-a01a9b833d98ba2ba66a52aa88fec3f4.jpg";